export const basicImage = "/src/img/logo/transparant_logo.png"

export enum CHAINS {
    testnet = "rebel-2",
    mainnet = "columbus-5",
}

export const CHAINS_SELECTED = "chain_selected";
export const URL = "https://api-bigbangx.garuda-defi.org";
export const CHAINS_USAGE = "columbus-5";

export const GAS_PRICE = "28.325";
export const DENOM = "uluna";
export const MULTIPLIER = 1.3;
export const TAX = 0.005;
export const RPC_URLS = {
    [CHAINS.testnet]: "https://rpc.luncblaze.com:443",
    [CHAINS.mainnet]: "https://terra-classic-rpc.publicnode.com:443",
};;
export const WC_PROJECT_ID = "90bd29bd5f8f1cf682ab8d4b07e8ff4d";
export const WALLET_ID_KEY = "WALLET_ID";
export const WALLET_TYPE_KEY = "WALLET_TYPE";


export const CLASSIC_CHAIN_ID = "columbus-5";
export const CLASSIC_GAS_PRICE = "28.325";
export const CLASSIC_DENOM = "uluna";
